import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Icon } from '@millionshow/client-libs';

@Component({
  selector: 'app-vision',
  imports: [CommonModule, Icon],
  templateUrl: './vision.component.html',
})
export default class VisionComponent {}
